module.exports = __webpack_public_path__ + "img/dark_box2_bg.f2fc2bd0.png";